module.exports = __webpack_public_path__ + "img/ewm.511fe56d.png";